export const COL_DEF_CHECK_BOX_OFF = [
  {
    cellRenderer: 'PartNumberCellRenderer',
    checkboxSelection: false,
    parameterId: 1111
  }
];

export const COL_DEF_SORT_FILTER_PARTSTATUS_ON = [
  {
    filter: true,
    sortable: true,
    parameterId: 1989
  }
];

export const COL_DEF_SET_CHECKBOX = [
  {
    cellRenderer: 'reverseCheckboxCellRenderer'
  }
];

export const COL_DEF_SET_PINED_LEFT_COL = [
  {
    pinned: 'left'
  }
];
export const COL_DEF_SET_PINED_RIGHT_COL = [
  {
    pinned: 'right'
  }
];

export const COL_DEF_UN_SET_PINED_COL = [
  {
    pinned: null
  }
];

export const COL_DEF_CHECK_BOX_ON = [
  {
    cellRenderer: 'PartNumberCellRenderer',
    checkboxSelection: true,
    parameterId: 1111
  }
];

export const BOTTOM_OPTIONS = {
  alignedGrids: [],
  rowHeight: 0,
  headerHeight: 0
};

export const TOP_OPTIONS = {
  alignedGrids: [],
  defaultColDef: {
    resizable: true,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    filter: 'agSetColumnFilter',
    filterParams: {
      applyMiniFilterWhileTyping: true,
      buttons: ['apply', 'clear', 'reset'],
      newRowsAction: 'keep'
    },
    menuTabs: ['filterMenuTab', 'generalMenuTab'],
    autoHeaderHeight: true,
     wrapHeaderText: true
  },
  rowHeight: 90,
  domLayout: 'autoHeight',
  pagination: true,
  paginationPageSize: 25,
  enableCellTextSelection: true,
  ensureDomOrder: true,
  suppressRowHoverHighlight: true,
  suppressMenuHide: true,
  rowSelection: 'multiple',
  suppressRowClickSelection: true,
  rowBuffer: 9999,
  suppressPropertyNamesCheck: true,
  useValueFormatterForExport: true,
  tooltipShowDelay: 300,
  headerHeight: 65
};

export const TOP_OPTIONS_UNLOGGED = {
  alignedGrids: [],
  defaultColDef: {
    resizable: true,
    sortable: false,
    wrapText: true,
    autoHeight: true,
    filter: false,
    filterParams: {
      applyMiniFilterWhileTyping: true,
      buttons: ['apply', 'clear', 'reset'],
      newRowsAction: 'keep'
    },
    menuTabs: ['filterMenuTab', 'generalMenuTab'],
    autoHeaderHeight: true,
    wrapHeaderText: true
  },
  rowHeight: 90,
  domLayout: 'autoHeight',
  pagination: true,
  paginationPageSize: 25,
  enableCellTextSelection: true,
  ensureDomOrder: true,
  suppressRowHoverHighlight: true,
  suppressMenuHide: true,
  rowSelection: 'multiple',
  suppressRowClickSelection: true,
  rowBuffer: 9999,
  suppressPropertyNamesCheck: true,
  useValueFormatterForExport: true,
  tooltipShowDelay: 300,
  headerHeight: 65
};

export const REVERSE_SEARCH_GRID_OPTIONS = {
  // use for unlogged
  alignedGrids: [],
  defaultColDef: {
    resizable: true,
    sortable: false,
    wrapText: true,
    autoHeight: true,
    filter: false,
    filterParams: {
      applyMiniFilterWhileTyping: true,
      buttons: ['apply', 'clear', 'reset'],
      newRowsAction: 'keep'
    },
    menuTabs: ['filterMenuTab', 'generalMenuTab'],
    wrapHeaderText: true
  },
  rowHeight: 90,
  domLayout: 'autoHeight',
  enableCellTextSelection: true,
  ensureDomOrder: true,
  suppressRowHoverHighlight: true,
  suppressMenuHide: true,
  rowSelection: 'multiple',
  suppressRowClickSelection: true,
  rowBuffer: 9999,
  suppressPropertyNamesCheck: true,
  headerHeight: 65

  // use for logged need to discus
  // alignedGrids: [],
  // defaultColDef: {
  //   resizable: true,
  //   sortable: true,
  //   wrapText: true,
  //   autoHeight: true,
  //   filter: 'agSetColumnFilter',
  //   filterParams: {
  //     applyMiniFilterWhileTyping: true,
  //     buttons: ['apply', 'clear', 'reset'],
  //     newRowsAction: 'keep'
  //   },
  //   menuTabs: ['filterMenuTab', 'generalMenuTab']
  // },
  // rowHeight: 90,
  // domLayout: 'autoHeight',
  // enableCellTextSelection: true,
  // ensureDomOrder: true,
  // suppressRowHoverHighlight: true,
  // unSortIcon: true,
  // suppressMenuHide: true,
  // rowSelection: 'multiple',
  // suppressRowClickSelection: true,
  // rowBuffer: 9999
};

export const EXECL_STYLE: any = [
  {
    id: 'rag-green',
    interior: {
      color: '#E2EFDA',
      pattern: 'Solid'
    }
  },
  {
    id: 'source-part-excel',
    interior: {
      color: '#C8DDDB',
      pattern: 'Solid'
    }
  },
  {
    id: 'multiline',
    alignment: {
      wrapText: true
    }
  },
  {
    id: 'stringType',
    dataType: 'String'
  },
  {
    id: 'cell',
    borders: {
      borderBottom: {
        lineStyle: 'Continuous',
        weight: 1
      },
      borderLeft: {
        lineStyle: 'Continuous',
        weight: 1
      },
      borderRight: {
        lineStyle: 'Continuous',
        weight: 1
      },
      borderTop: {
        lineStyle: 'Continuous',
        weight: 1
      }
    }
  },
  {
    id: 'header',
    borders: {
      borderBottom: {
        lineStyle: 'Continuous',
        weight: 1
      },
      borderLeft: {
        lineStyle: 'Continuous',
        weight: 1
      },
      borderRight: {
        lineStyle: 'Continuous',
        weight: 1
      },
      borderTop: {
        lineStyle: 'Continuous',
        weight: 1
      }
    }
  }
];
